'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalogLocation = require('./remote/catalogLocation');

var CatalogLocation = {
    fetchCatalogLocations: function fetchCatalogLocations(params) {
        return _catalogLocation.CatalogLocationRemote.fetchCatalogLocations(params);
    }
};

exports.default = CatalogLocation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/catalogLocation.js
// module id = AMoU
// module chunks = 46